import * as React from 'react';
import TooltipTrigger from 'components/TooltipTrigger';

/* ************************************** */
/* DEPRECATED: Use TooltipTrigger instead */
/* ************************************** */

type TooltipableProps = {
  tooltip?: React.ReactNode;
  tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left';
  tooltipAlignment?: 'top' | 'right' | 'bottom' | 'left';
};

/* HOC
 *
 * Make any component tooltip ready
 * this mean any parent component can add tooltip to
 * the wrapper component by passing a tooltip prop to it.
 */
export default function tooltipable<Props>(Component: React.ComponentType<Props>) {
  // return functional component
  const wrapped = (props: TooltipableProps & Props) => {
    const { tooltip, tooltipPlacement, tooltipAlignment, ...rest } = props;
    const blah: Props = rest as Props;
    if (!tooltip) {
      return <Component {...blah} />;
    }

    return (
      <TooltipTrigger tooltip={tooltip} placement={tooltipPlacement} alignment={tooltipAlignment}>
        <Component {...blah} />
      </TooltipTrigger>
    );
  };

  wrapped.displayName = Component.displayName || Component.name;

  return wrapped;
}
